module.exports = __webpack_public_path__ + "static/img/zsdy.8cdbd42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/zsdy.jpg
// module id = v+he
// module chunks = 1